import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  checkString,
  noDataFound,
  splitDate,
  splitNormal,
  truncate,
} from "../../../../CommonMethhods/CommonMethods";
import {
  Get_Details,
  // LoginInfo_Active_Inactive,
} from "../../../../Configuration/API_URL";
import { Constants } from "../../../../CommonMethhods/Constants";
import { Modal } from "react-bootstrap";

function KycSupport() {
  let count = 0;
  let clientCode = "";
  const storeToken = localStorage.getItem("ssoToken");
  const [pendingCount, setPendingCount] = useState(0);
  const [openCount, setOpenCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [total, setTotal] = useState(0);
  const [checkSession, setCheckSession] = useState();
  const [closeData, setCloseData] = useState([]);
  const [openData, setOpenData] = useState([]);
  const [bothData, setBothData] = useState([]);

  const [modalShowOpen, setModalShowOpen] = useState(false);
  const [modalShowClose, setModalShowClose] = useState(false);

  const SupportTicket = async (clientCode) => {
    try {
      const getTicketDetail = await axios.post(
        Get_Details.Get_Ticket_Details_URL,

        {
          userName: clientCode,
        },

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const res = getTicketDetail.data.data;
      setLoader(false);
      ticketCount(res);
      if (res.length > 0) {
        setBothData(res);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  //ticket coversation api start
  const GetTicketConverstaion = async (clientCode) => {
    try {
      const getConversation = await axios.post(
        Get_Details.Get_Ticket_Coversation,

        {
          userName: clientCode,
          requestType: "SM08GENERAL",
          ticketId: "74704",
          subject: "",
        },

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const conversationResponse = getConversation.data.data;
    } catch (error) {
      console.log(error);
    }
  };
  //ticket coversation end

  // const ActiveInactiveSession = async (clientCode) => {
  //   let authKey ="bajajsecmsil2022"
  //   try {
  //     const getSessionDetail = await axios.post(
  //       LoginInfo_Active_Inactive.Get_Login_Info_URL,

  //       {
  //         request: { data: { userId: clientCode }, appID: "client-login-api" },
  //       },

  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-ENCRYPT": "false",
  //           "AUTH-KEY": authKey,
  //           // Authorization: `Bearer ${storeToken}`,
  //         },
  //       }
  //     );
  //     const activeResp = getSessionDetail?.data?.response?.data;
  //     setCheckSession(activeResp);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  function handleOnclick(status) {
    if (status === "Pending") {
      setModalShowOpen(true);
    } else if (status === "Close") {
      setModalShowClose(true);
    }
  }

  const ticketCount = (res) => {
    let total = res.length;
    setTotal(total);
    res.filter((item) => {
      if (item.status.toLowerCase() == "closed") {
        count = count + 1;
      }
      setPendingCount(total - count);
      setOpenCount(count);
    });
  };
  const onHide = () => {
    setModalShowOpen(false);
    setModalShowClose(false);
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      SupportTicket(clientCode);
      // ActiveInactiveSession(clientCode);
      GetTicketConverstaion(clientCode);
    }
    // if (modalShowClose === true) {
    //   SupportTicket(clientCode);
    // }
  }, []);

  const showModalCloseData = () => {
    return bothData
      .filter((value) => {
        return value.status === "Closed";
      })
      .map((info, key) => {
        return (
          <tr key={key}>
            <td>
              {info.ticketId == "" || undefined || null ? "-" : info.ticketId}
            </td>
            <td className="tooltip123">
              {truncate(
                info.subject === "" || undefined || null ? "-" : info.subject
              )}
              {info.userQuery.length > 14 ? (
                <span className="tooltiptext">
                  {info.subject === "" || undefined || null
                    ? "-"
                    : info.subject}
                </span>
              ) : (
                ""
              )}
            </td>
            <td className="tooltip123">
              {truncate(
                info.userQuery === "" || undefined || null
                  ? "-"
                  : info.userQuery
              )}
              {info.userQuery.length > 14 ? (
                <span className="tooltiptext">
                  {info.userQuery === "" || undefined || null
                    ? "-"
                    : info.userQuery.replace(
                        /(<\/?(?:a|p|img)[^>]*>)|<[^>]+>/gi,
                        "$1"
                      )}
                </span>
              ) : (
                ""
              )}
            </td>
            <td>
              {info.requestType === "" || undefined || null
                ? "-"
                : info.requestType}
            </td>
            <td className="tooltip123">
              {truncate(
                info.closingNote === "" || undefined || null
                  ? "NA"
                  : info.closingNote
              )}
              {info.closingNote.length > 14 ? (
                <span className="tooltiptext">
                  {info.closingNote === "" || undefined || null
                    ? "NA"
                    : info.closingNote}
                </span>
              ) : (
                ""
              )}
            </td>
            <td>
              {info.createdAt === "" || undefined || null
                ? "-"
                : splitDate(info.createdAt)}
            </td>
            <td>
              {info.closedDate === "" || undefined || null
                ? "-"
                : splitDate(info.closedDate)}
            </td>
            <td>
              {info.status === "" || undefined || null ? "-" : info.status}
            </td>
          </tr>
        );
      });
  };
  const showModalOpenData = () => {
    return bothData
      .filter((value) => {
        return value.status !== "Closed";
      })
      .map((info, key) => {
        return (
          <tr key={key}>
            <td>
              {info.ticketId == "" || undefined || null ? "-" : info.ticketId}
            </td>
            <td className="tooltip123">
              {truncate(
                info.subject === "" || undefined || null ? "-" : info.subject
              )}
              {info.userQuery.length > 14 ? (
                <span className="tooltiptext">
                  {info.subject === "" || undefined || null
                    ? "-"
                    : info.subject}
                </span>
              ) : (
                ""
              )}
            </td>
            <td className="tooltip123">
              {truncate(
                info.userQuery === "" || undefined || null
                  ? "-"
                  : info.userQuery
              )}
              {info.userQuery.length > 14 ? (
                <span className="tooltiptext">
                  {info.userQuery === "" || undefined || null
                    ? "-"
                    : info.userQuery.replace(
                        /(<\/?(?:a|p|img)[^>]*>)|<[^>]+>/gi,
                        "$1"
                      )}
                </span>
              ) : (
                ""
              )}
            </td>
            <td>
              {info.requestType === "" || undefined || null
                ? "-"
                : info.requestType}
            </td>
            <td className="tooltip123">
              {truncate(
                info.closingNote === "" || undefined || null
                  ? "NA"
                  : info.closingNote
              )}
              {info.closingNote.length > 14 ? (
                <span className="tooltiptext">
                  {info.closingNote === "" || undefined || null
                    ? "NA"
                    : info.closingNote}
                </span>
              ) : (
                ""
              )}
            </td>
            <td>
              {info.createdAt === "" || undefined || null
                ? "-"
                : splitDate(info.createdAt)}
            </td>
            <td>
              {info.closedDate === "" || undefined || null
                ? "-"
                : splitDate(info.closedDate)}
            </td>
            <td>
              {info.status === "" || undefined || null ? "-" : info.status}
            </td>
          </tr>
        );
      });
  };

  const splitDate = (createddatetime) => {
    let date = createddatetime.split(" ")[0];
    return date;
  };

  return (
    <>
      {/* <!-- support --> */}
      <div className="col-md-12 col-lg-7">
        <div className="card-box kyc-card">
          <div className="card-title">
            <h2>{Constants.Support}</h2>
          </div>
          <div className="kyc-card__bottom ">
            <div>
              <h3 className="title">{Constants.Tickets_Raised}</h3>
              <h4 className="values">{total}</h4>
            </div>
            <div>
              <h3 className="title">{Constants.Tickets_Close}</h3>
              <h4
                className="values Open-value"
                onClick={() => handleOnclick("Close")}
              >
                {openCount}
              </h4>
            </div>
            <div>
              <h3 className="title">{Constants.Tickets_Pending}</h3>
              <h4
                className="values pending-value"
                onClick={() => handleOnclick("Pending")}
              >
                {pendingCount}
              </h4>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- active/inctive session --> */}
      <div className="col-md-12 col-lg-5">
        <div className="card-box kyc-card">
          <div className="card-title">
            <h2>{Constants.Active_Inactive_Session}</h2>
          </div>
          <div className="kyc-card__bottom ">
            <div>
              <h3 className="title">{Constants.Last_Logged_In}</h3>
              <p className="subtitle">
                {checkSession?.lastLoginTime
                  ? splitDate(checkSession?.lastLoginTime)
                  : "NA"}
              </p>
            </div>
            <div>
              <h3 className="title">Last Logged In Device</h3>
              <p className="subtitle">
                {/* 21 Days */}
                <p className="subtitle">{checkSession?.build || "NA"}</p>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* open modal */}
      <Modal
        show={modalShowOpen}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="trading-transaction-model setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.Tickets_Pending}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-kyc-table">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">TicketId</th>
                  <th scope="col">Subject</th>
                  <th scope="col">User Query</th>
                  <th scope="col">Request Type</th>
                  <th scope="col">Closing Note</th>
                  <th scope="col">Create Date</th>
                  <th scope="col">Closed Date</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              {bothData.filter((value) => value.status !== "Closed").length >
              0 ? (
                <tbody id="trading-model kyc-modal">
                  {showModalOpenData()}
                </tbody>
              ) : (
                noDataFound()
              )}
            </table>
          </div>
        </Modal.Body>
      </Modal>
      {/* open modal end */}

      {/* close modal */}
      <Modal
        show={modalShowClose}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="trading-transaction-model setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p>{Constants.Tickets_Close}</p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-kyc-table">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">TicketId</th>
                  <th scope="col">Subject</th>
                  <th scope="col">User Query</th>
                  <th scope="col">Request Type</th>
                  <th scope="col">Closing Note</th>
                  <th scope="col">Create Date</th>
                  <th scope="col">Closed Date</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              {bothData.filter((value) => value.status === "Closed").length >
              0 ? (
                <tbody id="trading-model kyc-modal">
                  {showModalCloseData()}
                </tbody>
              ) : (
                noDataFound()
              )}
            </table>
          </div>
        </Modal.Body>
      </Modal>
      {/* close modal end */}
    </>
  );
}

export default KycSupport;
